export enum UtmParameterEnum {
  utm_source = 'utm_source',
  utm_medium = 'utm_medium',
  utm_content = 'utm_content',
  utm_campaign = 'utm_campaign',
  utm_term = 'utm_term',
}
export const UtmParameterTranslationEnum = {
  [UtmParameterEnum.utm_source]: 'dashboard.user.utm_source',
  [UtmParameterEnum.utm_medium]: 'dashboard.user.utm_medium',
  [UtmParameterEnum.utm_content]: 'dashboard.user.utm_content',
  [UtmParameterEnum.utm_campaign]: 'dashboard.user.utm_campaign',
  [UtmParameterEnum.utm_term]: 'dashboard.user.utm_term',
}
